import { lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { TableProvider } from "./context/tableContext";
import { FileUploadProvider } from "./context/fileUploadContext";
import withAuth from "./hoc/withAuth";
import ResetPassword from "./pages/Auth/ResetPassword";
import Login from "./pages/Auth/Login";
import MainLayout from "./layout/main";
import ForgotPassword from "./pages/Auth/ForgotPassword";

const Inventory1 = withAuth(lazy(() => import("./pages/Inventory1")));
const Inventory2 = withAuth(lazy(() => import("./pages/Inventory2")));

function App() {
  return (
    <Router>
      <Suspense fallback={
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          fontFamily: 'Poppins'
        }}>
          Loading...
        </div>
      }>
        <Routes>
          <Route
            element={
              <FileUploadProvider>
                <TableProvider>
                  <MainLayout />
                </TableProvider>
              </FileUploadProvider>
            }
          >
            <Route path="/inventory1" element={<Inventory1 />} />
            <Route path="/inventory2" element={<Inventory2 />} />
            <Route path="/dashboard" element={<></>} />
            <Route path="*" element={<Navigate to="/inventory2" replace />} />
          </Route>
          <Route path="/" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
